module.exports = __webpack_public_path__ + "img/img_61284_0_4.13f7d982.png";